export default "__VITE_ASSET__CFIHCAGm__"